<script setup lang="ts">
import DocumentVerification from '~/components/user/user-document-verification.vue';
import { ESumSubAction } from '~/interfaces/dto/compliance/request';
const authStore = useAuthStore();

const sumsubActive = ref<boolean>(false);

const sumSubVerificationType = computed<ESumSubAction>(() =>
  authStore.currentUser.idNumberType.toLocaleLowerCase() === 'idnumber'
    ? ESumSubAction.DocumentVerify
    : ESumSubAction.PassportVerify,
);

onMounted(() => (sumsubActive.value = authStore.getSumsubRequired));

const toggleSumSub = (active: boolean) => (sumsubActive.value = active);
</script>

<template>
  <LazyUserAccountSettingsHeader :title="''" return-route="settings" />
  <UserSumsub
    :model-value="sumsubActive"
    :action="sumSubVerificationType"
    display-error
    @complete="toggleSumSub(false)"
    @error="toggleSumSub(false)"
  >
    <DocumentVerification @activate-sum-sub="toggleSumSub(true)" />
  </UserSumsub>
</template>

<style scoped></style>
